import React, { useEffect, useState } from 'react';
import { Pagination } from '../_components';
import Loading from '../_components/Loading';
import { NoData } from '../_components/NoData';
import { isNotExpired } from '../_services';
import { notesService } from '../_services/notes.service';
import { NoteItem } from './NoteItem';

const NotesList = ({ subject_id }) => {
  const [notesData, setNotesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [subscription, setSubscription] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  useEffect(() => {
    if (subject_id) {
      getAllNotes(subject_id);
    }
  }, [subject_id]);

  const getAllNotes = async (id) => {
    try {
      setIsLoading(true);
      const response = await notesService.notesList({ subject_id: id });
      if (response?.data?.rows?.length) {
        setNotesData(response.data.rows);
      }
      setPaginationData({
        page: response.data.page,
        pages: response.data.pages,
      });

      const subscriptionStatus = checkSubscription(response?.data?.subscriptiondetails[0]);

      setSubscription(subscriptionStatus);
    } catch (err) {
      console.log(err, 'this si error');
    } finally {
      setIsLoading(false);
    }
  };

  const checkSubscription = (item) => {
    let notExpired = isNotExpired(item?.expiry_date);

    if (item?.payment_status == 1 && notExpired) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div>
      <div className='min-height-50'>
        {/* <div className='topichead mb-5'>Topics</div> */}
        <div className='d-flex align-items-center gap-1'>
          <div className='d-flex flex-wrap gap-4 courselist'>
            {notesData?.map((noteData) => {
              return (
                <NoteItem note={noteData} key={noteData._id} subscriptionStatus={subscription} />
              );
            })}
          </div>
        </div>

        {notesData?.length == 0 && !isLoading && <NoData text='No Notes Found' />}
        {isLoading && notesData.length == 0 && <Loading />}
        <Pagination pageOnClick={(pageNo) => getAllNotes(pageNo)} demoData={paginationData} />
      </div>
    </div>
  );
};

export default NotesList;
